module.exports = __webpack_public_path__ + "static/media/account_info_4.976c9311.png";